import { Entity } from './entity';

export class ModuleMenuItem {
  moduleId: number;
  moduleParentTextname: string;
  moduleTextname: string;
  moduleDescription: string;
  moduleEnabled: boolean;
  moduleIcon: string;
  moduleLink: string;
  moduleAdmin: boolean;
  moduleExpanded = false;
}

export class SidemenuItem extends Entity {
  sidemenuId: number;
  sidemenuIcon: string;
  sidemenuLink: string;
  sidemenuModule: string;
  sidemenuModuleId: number;
  sidemenuModuleTextname: string;
  sidemenuName: string;
  sidemenuUppername: string;
  sidemenuSubscribed: boolean;
  sidemenuHelpLink: string;
  hide?: boolean;
}
